import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NavigateToNodeWithData, NodeNavigatorActionTypes } from '@ispm-client/modules/bpmn-modeler/store/actions/node-navigator.action';
import { BpmnModelerService } from '@ispm-client/modules/bpmn-modeler/service/bpmn-modeler.service';

@Injectable()
export class NavigateNodeWithDataEffect {

  constructor(private actions$: Actions,
              private bpmnModelerService: BpmnModelerService) {
  }

  @Effect({ dispatch: false})
  navigateToNodeWithDataEffect$: Observable<Action> = this.actions$
    .pipe(
      ofType<NavigateToNodeWithData>(NodeNavigatorActionTypes.NAVIGATE_TO_NODE_WITH_DATA),
      tap((action: NavigateToNodeWithData) => {
        return this.bpmnModelerService.navigateToNodeWithData(action.payload.nodeId, action.payload.openPanel,action.payload.data);
      })
    );

}
